module.exports = __webpack_public_path__ + "static/media/illustration-element-06.cce243f2.svg";